import { useEffect, useState } from 'react';

export type AsyncState<T> = { status: 'idle' } | { status: 'loading' } | { status: 'success'; data: T } | { status: 'error'; error: Error };

const toError = (e: unknown): Error => (e instanceof Error ? e : new Error(String(e)));

export const useAsync = <T>(fn: () => Promise<T>, deps: ReadonlyArray<unknown>): AsyncState<T> => {
    const [state, setState] = useState<AsyncState<T>>({ status: 'loading' });

    useEffect(() => {
        let cancelled = false;
        setState({ status: 'loading' });
        fn().then(
            (data) => {
                if (!cancelled) {
                    setState({ status: 'success', data });
                }
            },
            (e: unknown) => {
                if (!cancelled) {
                    setState({ status: 'error', error: toError(e) });
                }
            },
        );
        return () => {
            cancelled = true;
        };
        // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return state;
};
